import useGetApi from '@/api/useGetApi';

interface InventoryData {
  icomp: string | null;
  isupp: string | null;
  iinvno: string | null;
  invdat: string | null;
  iiline: string | null;
  idiv: string | null;
  iloc: string | null;
  idept: string | null;
  fileThreeLetterDivision: string | null;
  icamt: number | null;
  iqty: number | null;
  ipoord: string | null;
  ipolin: string | null;
  iprod: string | null;
  ipoqty: number | null;
  icost: number | null;
  ipocst: number | null;
  ircost: number | null;
  irqty: number | null;
  irdat: string | null;
  ibuyer: string | null;
  idescr: string | null;
  idudat: string | null;
  iordat: string | null;
  ididat: string | null;
  idiamt: number | null;
  indamt: number | null;
  iforce: boolean | null;
  ihold: boolean | null;
  idate: string | null;
}

export interface TransactionDetail {
  // Basic Info
  id: string;
  tradingPartner: string;
  fileThreeLetterDivision: string;
  company?: string;
  division?: string;
  rebateType?: string;
  transactionType?: string;

  // Order Info
  rexelSalesOrderNumber?: string;
  orderDate?: string;
  customerPoNumber?: string;
  backOrderLevel?: string;
  backOrderShipmentNumber?: string;
  salesOrderLineNumber?: string;

  // Item Info
  itemInternalCode?: string;
  itemInternalCodeSuffix?: string;
  description?: string;
  supplierItemCode?: string;
  upcManufacturerCode?: string;
  upcProductCode?: string;
  orderUom?: string;
  pricingUom?: string;
  stockedFlag?: boolean;
  potfFlag?: boolean;

  // Customer Info
  customerNo?: string;
  customerSoldToAccountNumber?: string;
  customerShipToAccountNumber?: string;
  customerName?: string;
  customerShipToAddress1?: string;
  customerShipToAddress2?: string;
  customerShipToCity?: string;
  customerShipToStateProvince?: string;
  customerShipToPostalCode?: string;
  customerShipToCountryCode?: string;

  // Branch Info
  sellingBranchCode?: string;
  shippingBranchCode?: string;
  sellingBranchName?: string;
  shippingBranchName?: string;
  sellingLocationFullName?: string;
  territoryCode?: string;

  // Invoice Info
  invoiceNumber?: string;
  invoiceDate?: string;
  shipmentDate?: string;

  // Quantity Info
  originalQuantity?: number;
  allocatedQuantity?: number;
  shippedQuantity?: number;
  canceledAdjustedQuantity?: number;

  // Pricing Info
  listPrice?: number;
  customerInvoiceAmount?: number;
  claimAmount?: number;
  pricingMethod?: string;
  costOverrideFlag?: string;

  // Agreement Info
  agreementNumber?: string;
  agreementLineNumber?: string;
  agreementReferenceNumber?: string;
  agreementDescriptionLine1?: string;
  agreementDescriptionLine2?: string;
  agreementDescriptionLine3?: string;
  agreementStartDate?: string;
  agreementEndDate?: string;
  agreementType?: string;
  agreementStatus?: string;
  agreementCostOverride?: number;
  supplierContractNumber?: string;

  // Cost Info
  buyerCost?: number;
  divisionalLandedCost?: number;
  divisionalCoreCost?: number;
  actualOverrideCost?: number;
  coreCostOverride?: number;
  extendedCoreCostOverride?: number;
  extendedBuyerCost?: number;
  varianceOverBuyer?: number;
  varianceOverInvCs?: number;

  ediSupplierFlag?: string;

  // Timestamps
  createdAt: string;
  updatedAt: string;

  // Related Data
  inventoryData: InventoryData[] | null;

  // Status
  sent?: boolean;
}

interface TransactionDetailResponse {
  transaction: TransactionDetail;
}

export const useRexelShipAndDebitTransaction = (transactionId?: string) => {
  return useGetApi<TransactionDetailResponse>({
    endpoint: transactionId
      ? `rexel/ship-and-debit/844/transactions/${transactionId}`
      : '',
    options: {
      enabled: !!transactionId,
    },
  });
};
